import CommonTimeSheetTable from "../../components/common/Timesheet/TimesheetTable";

const TimeSheet = () => {
  return (
    <>
      <CommonTimeSheetTable updatePath="task/timelog" isModule={true} />
    </>
  );
};
export default TimeSheet;
